import http from '../api/http';

export default {
    login(pat,callback){ // 登录
        http.post('/v1/venue/login', pat).then(res => {
            callback(res,'login')
        }).catch(err => {
            callback(err,'login')
        })
    },
    note({params, callback}){ // 发送短信
        http.post(`/v1/venue/sendSmsCode/pwd`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    alPassword({params, callback}){ // 修改密码
        http.put(`/v1/venue/forgetPassWord`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    logout({callback}){ // 登录
        http.post('/v1/venue/logout').then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    check({params, callback}){ // 校验短信验证码
        http.post(`/v1/venue/checkCode/pwd`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    pinNote({callback}){ // 发送短信
        http.post(`/v1/venue/sendSmsCode/pin`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    pinCheck({params, callback}){ // 校验短信验证码
        http.post(`/v1/venue/checkCode/pin`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    alPin({params, callback}){ // 修改
        http.put(`/v1/venue/forget-pin`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    pinUpdate({params, callback}){ // 修改
        http.put(`/v1/venue/update-pin`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    getSubVenueList({params, callback}){ // 获取主场馆下所有子场馆信息
        http.get(`/v1/venue/getSubVenueList`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    ordersRevenueDailyToday({callback}){
        http.post(`/v1/home-dashboard/dashBoard-syc-OrdersRevenueDailyToday`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },

    // MENARD NEW ==============================================================================
    
    venueDailyOverview({params, callback}) {
        let url = `/v1/venue/subvenues/${params.weekName}/${params.startTime}/${params.endTime}`
        http.get(url).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },

    venueWeeklyOverview({params, callback}) {
        let url = `/v1/venue/subvenues/${params.startTime}/${params.endTime}`
        http.get(url).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },

    async userPasswordSet(payload) {
        let url = `/v1/api-app/user-password-set`
        return await http.post(url, payload)
    }
}


// WEBPACK FOOTER //
// ./src/api/login.js